import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
// Our axios Instance
import axiosInstance from 'services/API/API';

// Our Query Keys
import { FA_TOTAL_LIABILITIES } from 'shared/query-keys';

// Our End points
import { faSummaryV2 } from 'shared/api-urls';

// Our Routes
import { LOGIN_ROUTE } from 'routes/index';

// our constants
import { DEFAULT_STALE_TIME_FIVE_MINUTES } from 'shared/constants';

const PAGE_SIZE = 10;

const getNextPageOffset = (pageNumber) => {
	const offset = pageNumber * PAGE_SIZE;
	return offset;
};

function useGetFaTotalLiabilities(select = (data) => data) {
	const navigate = useNavigate();

	return useQuery(
		[FA_TOTAL_LIABILITIES],
		async () => {
			const offsetByPageNumber = getNextPageOffset(0);

			const params = {
				offset: offsetByPageNumber,
				pagesize: PAGE_SIZE
			};

			const response = await axiosInstance.get(faSummaryV2, {
				params
			});

			const faSummaryData = response.data.data;

			return faSummaryData;
		},
		{
			onError: (error) => {
				navigate(LOGIN_ROUTE);
			},
			select,
			staleTime: DEFAULT_STALE_TIME_FIVE_MINUTES
		}
	);
}

export default useGetFaTotalLiabilities;
